import { IUrlId } from "@faire/retailer/models/Category/IUrlId";

interface ObjectWithUrlId {
  url_id: string | undefined;
}
export const categoryToUrlId = (category?: ObjectWithUrlId): IUrlId => {
  return { id: category?.url_id ?? "" };
};
